import React from "react";

const InputField = ({ label, value, onChange, ...props }) => (
  <div
    className={`relative mb-2 flex w-full ${
      props.type === "checkbox" ? "flex-row-reverse items-end" : "flex-col items-end"
    }`}
  >
    <label
      className={`font-medium text-base mb-2 ${
        props.type === "checkbox" ? "flex justify-end" : ""
      }`}
    >
      {label}
    </label>
    <input
      value={value}
      dir="rtl"
      onChange={onChange}
      className={` bg-white py-2 mb-2 px-4 border rounded ${
        props.type === "checkbox" ? "w-auto mr-8" : "w-full"
      }`}
      {...props}
    />
  </div>
);

export default InputField;
